module.exports = "\n.disabled {\n  pointer-events: none;\n  /* for \"disabled\" effect */\n  /*opacity: 0.5;*/\n  color: #CECECE;\n}\n\n.selectBtn{\n  font-size:12px;\n  margin-left:5px;\n  padding:5px 15px;\n  margin-bottom:5px;\n  border:1px solid #CECECE;\n\n}\n\n.selectBtn:hover{\n  background-color:#3AB44A!important;\n}\n\n.selectBtnDiv{\n  width: auto!important;\n}\n\n.marginBottom{\n  margin-bottom:5px;\n}\n\n.marginBottomClass{\n  margin-bottom:5px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/Screens/advance-game/advance-game.component.css
// module id = ./src/app/Screens/advance-game/advance-game.component.css
// module chunks = main